import type { ButtonGroupAlign, ButtonGroupDirection } from "./buttonGroup.types";
import type { JSX } from "react";

import * as styles from "./buttonGroup.module.scss";

export type OneOrMore<T> = T | T[];
export type ButtonGroupChildren = JSX.Element | JSX.Element[] | null | undefined | boolean | "";

export function getButtonGroupDirectionClassName(direction: ButtonGroupDirection): string {
	switch (direction) {
		case "column":
			return styles.directionColumn ?? "";
		case "row":
			return styles.directionRow ?? "";
		default:
			return "";
	}
}

export function getButtonGroupAlignClassName(align: ButtonGroupAlign): string {
	switch (align) {
		case "start":
			return styles.alignStart ?? "";
		case "center":
			return styles.alignCenter ?? "";
		case "end":
			return styles.alignEnd ?? "";
		case "space-between":
			return styles.spaceBetween ?? "";
		default:
			return "";
	}
}
